import React, { Component } from "react";

class TournamentOptions extends Component {

  render() {

  var tournaments = this.props.tournaments;
    return (
      tournaments.map(function(tournament, i){
        return (
          <option value={tournament.Name}>{tournament.Name}</option>
        )
      })
    );
  }
}

export default TournamentOptions;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/TournamentOptions.js